import { FC, useRef } from "react";
import s from "./ResetSceneModal.module.scss";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import PlayCanvasService from "../../../services/PlayCanvasService/PlayCanvasService";
import { useAppDispatch } from "../../../redux/store";
import {
  resetDataScene,
  setDataHistory,
  setActiveObjectId,
  setActiveFolder,
} from "../../../redux/reducers/ui/uiReducer";

type ResetSceneModalProps = {
  closeFunc: () => void;
};

const ResetSceneModal: FC<ResetSceneModalProps> = ({ closeFunc }) => {
  const dispatch = useAppDispatch();
  const wrapperRef: any = useRef(null);

  const onConfirm = async () => {
    await PlayCanvasService.clearScene();

    dispatch(resetDataScene());
    dispatch(setDataHistory({ dataHistory: null }));
    dispatch(setActiveObjectId(null));
    dispatch(setActiveFolder(null));

    closeFunc();
  };

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <div className={s.head}>
        <div className={s.title}>Reset the scene</div>
        <div className={s.close} onClick={closeFunc}>
          <CloseIcon />
        </div>
      </div>
      <div className={s.titleWrapper}>
        <div className={s.modalBody}>
          <div className={s.subtitle}>
            <span>Are you sure you want to reset the scene?</span>
          </div>
        </div>
      </div>
      <footer>
        <div className={s.nav}>
          <div className={s.cancel} onClick={closeFunc}>
            Cancel
          </div>
          <div className={s.accept} onClick={onConfirm}>
            Continue
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ResetSceneModal;
